import "@/App.css";
import { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoadingScreen from "@/components/LoadingScreen";
import CookieBanner from "@/components/CookieBanner";
import HomePage from "@/components/HomePage";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";

function App() {
  const [loading, setLoading] = useState(true);
  const handleFinish = useCallback(() => setLoading(false), []);

  return (
    <BrowserRouter>
      {loading && <LoadingScreen onFinish={handleFinish} />}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#051F16',
            border: '1px solid #1D4133',
            color: '#F0FDF4',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
